var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineInfoCircle16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.3333C7.25 11.7475 7.58579 12.0833 8 12.0833C8.41421 12.0833 8.75 11.7475 8.75 11.3333H7.25ZM8.75 6.66667C8.75 6.25245 8.41421 5.91667 8 5.91667C7.58579 5.91667 7.25 6.25245 7.25 6.66667L8.75 6.66667ZM7.25 4.67331C7.25 5.08752 7.58579 5.42331 8 5.42331C8.41421 5.42331 8.75 5.08752 8.75 4.67331H7.25ZM8.75 4.66665C8.75 4.25243 8.41421 3.91665 8 3.91665C7.58579 3.91665 7.25 4.25243 7.25 4.66665H8.75ZM8.75 11.3333L8.75 6.66667L7.25 6.66667L7.25 11.3333H8.75ZM8.75 4.67331V4.66665H7.25V4.67331H8.75ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25V14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25ZM8 13.25C5.10051 13.25 2.75 10.8995 2.75 8H1.25C1.25 11.7279 4.27208 14.75 8 14.75V13.25ZM2.75 8C2.75 5.10051 5.10051 2.75 8 2.75V1.25C4.27208 1.25 1.25 4.27208 1.25 8H2.75ZM8 2.75C10.8995 2.75 13.25 5.10051 13.25 8H14.75C14.75 4.27208 11.7279 1.25 8 1.25V2.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineInfoCircle16);
export default __webpack_public_path__ + "static/media/outline-info-circle-16.8502cde0.svg";
export { ForwardRef as ReactComponent };